import React from 'react';
import OrderPropItem from "./OrderPropItem";
import {SVG__Ruble} from "../../SVG/SVG";

class OrderProps extends React.Component {
  render() {
    const {vars, totalPrice, deliveryPrice} = this.props;
    const totalPriceHTML = (totalPrice > 0) ? <span> {(totalPrice.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '))} <SVG__Ruble/></span> : this.props.zeroPrice;
    const deliveryPriceHTML = deliveryPrice ? <span>{deliveryPrice} <SVG__Ruble/></span> : <span> бесплатно</span>;

    return (
      <div className="order-props">
        <form action={vars.post_form_acton_uri} method="POST" name="ORDER_FORM" id="bx-soa-order-form" encType="multipart/form-data" onSubmit={this.props._onOrder}>
          <div dangerouslySetInnerHTML={{__html: vars.bitrix_sessid_post}}/>
          <input type="hidden" id="ID_PAY_SYSTEM_ID_1" name="PAY_SYSTEM_ID" value="1"/>
          <input type="hidden" name="PERSON_TYPE" value="1"/>
          <input type="hidden" name="confirmorder" id="confirmorder" value="Y"/>
          <div className="order-props__header">

            <h2>ОФОРМЛЕНИЕ ЗАКАЗА</h2>
          </div>
          <div className="order-props__body">
            {vars.items.map(item => <OrderPropItem key={item.id} item={item}/>)}
          </div>
          <div className="order-props__footer">
            <div className="order-props__total-block">
              <div className="__delivery">Доставка в пределах МКАД: <b>{deliveryPriceHTML}</b></div>
              <div className="__total-price">ИТОГО: <b>{totalPriceHTML}</b></div>
              <div className="__vat-text">включая НДС</div>
            </div>

            <button name="submitbutton" className="btn btn-primary-inverted btn-block" data-ya_goal={"cart_order_send"}><span>Оформить заказ</span></button>

            <div className="confirmation"> Нажимая кнопку "Оформить заказ", я принимаю условия <a href="/politika-konfidentsialnosti/" target="_blank">Политики
              конфиденциальности</a> и&nbsp;
              <a href="/polzovatelskoye-soglasheniye/" target="_blank">Пользовательского соглашения</a>
            </div>

          </div>
        </form>
      </div>
    );
  }
}

export default OrderProps;